module.exports = __webpack_public_path__ + "img/qrcode.c8be3f66.png";